import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { 
  SUBCOMMITTEE_MEMBER_LIST
} from 'manager/http-constants';
import { CONSTANT, DATE_FORMAT, } from 'src/app/shared/constant/constant';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { PlatformComponent } from '../../platform.component';
import { Table } from 'primeng/table';
import { SUBCOMMITTEE_MEMBER_CONSTANT } from './constant';
import { DatePipe } from '@angular/common';
import { ExportFileService } from 'src/app/shared/html-parts/export-file/export-file.service';

@Component({
  selector: 'app-f171',
  templateUrl: './f171.component.html',
  styleUrls: [
    './f171.component.scss',
    '../master.component.scss',
    '../../platform.component.scss',
  ],
})

/**
 * 分科会参加者一覧
 */
export class F171Component extends PlatformComponent {
  // 画面.検索フォーム
  f171SearchForm: FormGroup = this.formBuilder.group({
    // 年度・ シングルセレクト
    year: CONSTANT.EMPTY_STRING,
    // 分科会タイトル
    title: CONSTANT.EMPTY_STRING,
    // 設置団体名
    create_organization_name: CONSTANT.EMPTY_STRING,
  });

  /** テーブル状態 */
  @ViewChild('table') table: Table;

  header: string = '';

  //年度取得格納先
  yearList: object[] = [];

  // 検索結果一覧表示
  searchResultsList: object[] = new Array();

  // 件数格納先
  countTaskData: number = 0;
  
  // ダウンロードデータ作成用
  subcommitteeMemberDownload: object[] = new Array();

  // ダウンロード用分科会参加メンバー用リスト
  subcommitteeMemberDownloadList: object[] = new Array();

  // 分科会参加メンバー：団体名格納先
  organizationNameList: object[] = new Array();

  // 分科会参加団体数
  memberCount: number = 0;
  
  // ダウンロード用分科会参加メンバーヘッダ
  subCommittieeHeader: object[] = [
    {field: 'no', header: 'No'},
    {field: 'theme', header: '分科会タイトル'},
    {field: 'organization_name', header: '設置団体名称'},
    {field: 'full_name', header: '氏名'},
    {field: 'organizer_group_name', header: '団体名称'},
    {field: 'want', header: '本プラットフォームにおける活動で実現したいこと'},
    {field: 'user_kbn', header: 'メンバー区分'},
    {field: 'email', header: 'メールアドレス'},
  ];

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    public datePipe: DatePipe,
    private router: Router,
    private formBuilder: FormBuilder,
    private exportFileService: ExportFileService,
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // 年度の値を設定
    // 当年度取得
    let currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 3);
    this.f171SearchForm.setValue({
      year: currentDate.getFullYear(),
      title: CONSTANT.EMPTY_STRING,
      create_organization_name: CONSTANT.EMPTY_STRING,
    });
    // 2022年までの分科会一覧を取得
    for(let i = currentDate.getFullYear(); 2022 <= i; i--){
      this.yearList.push({
        "sp_name" : i + "年",
        "sp_code" : i,
      });
    }

    // 提案結果を取得
    this.getSearchResultsList();
  }

  /**
   * 課題・ソリューション結果を取得
   * @param f171SearchForm 検索条件
   */
  public getSearchResultsList(): void {
    // 画面.検索フォームから検索条件を取得
    // ※値渡し
    let f171SearchForm: any = JSON.parse(
      JSON.stringify(this.f171SearchForm.value)
    );

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(SUBCOMMITTEE_MEMBER_LIST);

    // 分科会参加者一覧検索結果を取得
    this.dbOperationService
      .getNoTemplateData(SUBCOMMITTEE_MEMBER_LIST, f171SearchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 分科会参加者一覧検索結果を格納
          this.searchResultsList = response.body;

          // noをnumberに変換(sort対策)
          this.searchResultsList.forEach((searchResult)=>{
            if(searchResult["no"] != "" && searchResult["no"] != undefined){
              searchResult["no"] = parseInt(searchResult["no"]);
            }
          });
          
          this.subcommitteeMemberDownloadList = new Array();
          // ダウンロード用データ作成
          this.searchResultsList.forEach((subcommitteeMember) => {
            this.subcommitteeMemberDownload = new Array();
            this.subcommitteeMemberDownload["no"] = subcommitteeMember['no'];
            this.subcommitteeMemberDownload["theme"] = subcommitteeMember['theme'];
            this.subcommitteeMemberDownload["organization_name"] = subcommitteeMember['organization_name'];
            this.subcommitteeMemberDownload["full_name"] = subcommitteeMember['full_name'];
            this.subcommitteeMemberDownload["organizer_group_name"] = subcommitteeMember['organizer_group_name'];
            this.subcommitteeMemberDownload["want"] = subcommitteeMember['want'];
            this.subcommitteeMemberDownload["user_kbn"] = subcommitteeMember['user_kbn']['name'];
            this.subcommitteeMemberDownload["email"] = subcommitteeMember['email'];
            // ダウンロード用のリストに追加する
            this.subcommitteeMemberDownloadList.push(this.subcommitteeMemberDownload);
          });
        } else {
          this.searchResultsList = new Array();
          this.subcommitteeMemberDownloadList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, SUBCOMMITTEE_MEMBER_LIST);
      });

    // テーブル状態が存在するか否か
    if (this.table) {
      // テーブル状態が存在する場合

      // テーブル状態をリセット
      this.table.reset();
    }
  }

  public toNumber(str: string){
    return parseInt(str); 
  }

  /**
   * CSV出力
   */
   public exportCSV() {
    // csvファイル名の設定
    const fileName =
      SUBCOMMITTEE_MEMBER_CONSTANT.CSV_FILENAME +
      CONSTANT.UNDERBAR +
      this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);

    // CSVファイル出力
    this.exportFileService.exportCsv(
      fileName,
      this.subCommittieeHeader,
      this.subcommitteeMemberDownloadList,
      false
    );
  }
}
